import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Form, Formik } from 'formik';
import { Button, Modal } from 'react-bootstrap';
import { TextArea, TextBox, DateBox } from '../../../shared/controls/form';
import * as Yup from 'yup';
import SelectBox from '../../../shared/controls/form/selectBox';
import aiImage from '../../../../src/assets/img/crm_home/header/ai.png';
import { AgGridReact } from 'ag-grid-react';
import TruncatedText from '../../../../src/shared/component/TruncateText';
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderProfileBlock from '../../../components/sharedChild/headerImage/headerProfileBlock';
import RegularQuoteForm from './regularQuoteForm';
import { getQuoteById, getQuoteList, getUserRole } from '../../../redux/selector';
import { useDispatch, useSelector } from 'react-redux';
import ChildProduct from '../../../components/sharedChild/childProduct';
import ChildSalesOrder from '../../../components/sharedChild/childSalesOrder';
import Timeline from '../../../components/sharedChild/timeline';
import Email from '../../../components/sharedChild/email/emails';
import Attachments from '../../../components/sharedChild/attachment/attachments';
import Notes from '../../../components/sharedChild/note/notes';
import apiServices from '../../../services/service';
import Loader from '../../../shared/component/Loader';
import {
  fetchDetailAndAppendToModule,
  fetchNotesAndAppendToModule,
  fetchQuoteItemsAndAppendToModule,
} from '../../../redux/actions';
import ComposeEmail from '../../../components/sharedChild/email/compose';
import { isLoadingByKey } from '../../../shared/controls/methods/getLoadingState';
import { toast } from 'react-toastify';
import EmailPopUp from '../../../components/sharedChild/emailPopUp';

const RegularQuoteView = () => {
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'quoteList');
  const [deletePopup, setDeletePopup] = useState(false);
  const [imageUrl, setImageUrl] = useState('/assets/images/crm/add-image-placeholder.svg');
  const [loading, setLoading] = useState(storeLoading);
  const [enrichedDataLoading, setEnrichedDataLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('overview');
  const [formData, setFormData] = useState([]);
  const [errormsg, setErrorMsg] = useState({});
  const [showPopup6, setShowPopup6] = useState(false);
  const [selectedNote, setSelectedNote] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedOptions, setSelectedOptions] = useState({});
  const searchParams = new URLSearchParams(location.search);
  const quoteID = searchParams.get('id');
  const quoteList = useSelector(getQuoteList);
  const [productsByAccountId, setProductByAccountId] = useState([]);
  const dispatch = useDispatch();
  const [showSendEmailPopup, setShowSendEmailPopup] = useState(false);
  const userRole = useSelector(getUserRole);
  const role = userRole || '';
  const isSystemManager = role === 'System Manager';

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  // const quoteLocalData = useSelector((state) => {
  //   const quoteId = location.state?.id || quoteID;
  //   const data = getQuoteById(state, quoteId);
  //   return {
  //     ...data,
  //     type: "view",
  //     from: "view",
  //   };
  // });

  const [quoteLocalData, setQuoteLocalData] = useState({
    ...(location.state || {}),
    type: 'view',
    from: 'view',
  });

  const quoteStoreData = useSelector((state) => {
    const quoteId = location.state?.id || quoteID; // Use the pre-fetched `leadID`
    return getQuoteById(state, quoteId);
  });
  console.log('🚀 ~ RegularQuoteView ~ quoteStoreData:', quoteStoreData);

  useEffect(() => {
    setQuoteLocalData((prev) => ({ ...prev, ...quoteStoreData }));
  }, [quoteStoreData]);

  const openSendEmailPopUp = () => {
    setShowSendEmailPopup(true);
  };

  // Function to close the fifth popup
  const closeSendEmailPopUp = () => {
    setShowSendEmailPopup(false);
    // setShowPopup4(false);
  };

  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };
  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '0px 0px -250px 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });
  });

  const handlePopupDelete = (note) => {
    setSelectedNote(note); // Store the note to delete
    setDeletePopup(true); // Open the delete confirmation popup
  };

  useEffect(() => {
    console.log('Active Tab:', activeTab);
  }, [activeTab]);

  const handleClickDataEnrichment = () => {
    setEnrichedDataLoading(true);
  };

  const handleClickOpenConvert = (type) => {
    if (type == 'Sales') {
      navigate('/sales/createSalesOrder', {
        state: {
          ...quoteLocalData,
          salesOwner: quoteLocalData?.quoteOwner,
          salesOwnerId: quoteLocalData?.quoteOwnerId,
          saleOrderDetails: quoteLocalData?.quoteDetails,
          quoteId: quoteLocalData?.id,
          quoteName: quoteLocalData?.subject,
          from: 'SalesView',
        },
      });
    } else {
      navigate('/sales/createInvoice', {
        state: {
          ...quoteLocalData,
          invoiceOwner: quoteLocalData?.quoteOwner,
          invoiceOwnerId: quoteLocalData?.quoteOwnerId,
          invoiceDetails: quoteLocalData?.quoteDetails,
          quoteId: quoteLocalData?.id,
          quoteName: quoteLocalData?.subject,
          from: 'QuoteView',
        },
      });
    }
  };

  const handleOpenEditForm = () => {
    navigate(`/quoteAI/regularQuoteEdit?id=${formData?.id}`, {
      state: formData,
    });
  };

  const sendEmailForQuote = async () => {
    try {
      const cleanedData = {
        ...quoteLocalData,
        quoteDetails:
          quoteLocalData.quoteDetails?.map(
            ({ createdDateTime, updatedDateTime, ...rest }) => rest
          ) || [],
      };

      // Remove startDate if it's null
      if (cleanedData.startDate == null) {
        delete cleanedData.startDate;
      }

      // Remove endDate if it's null
      if (cleanedData.endDate == null) {
        delete cleanedData.endDate;
      }

      if (cleanedData.validUntil == null) {
        delete cleanedData.validUntil;
      }

      const response = await apiServices.sendEmailForQuotePdf(cleanedData);

      if (response.status === 200 && response.data?.toLowerCase() === 'email sent successfully') {
        toast.success(response.data); // Show success toast
      } else {
        toast.error('Failed to send email.');
        console.error('Failed to send email:', response);
      }
    } catch (error) {
      toast.error('An error occurred while sending email.');
      console.error('Error sending quote email:', error);
    }
  };

  const downloadPdf = async () => {
    setLoading(true)
    try {
      // Prepare data to send (clean up if necessary)
      const cleanedData = {
        ...quoteLocalData,
        quoteDetails:
          quoteLocalData.quoteDetails?.map(
            ({ createdDateTime, updatedDateTime, ...rest }) => rest
          ) || [],
      };
      delete cleanedData.notesList;
      delete cleanedData.createdDateTime;
      delete cleanedData.updatedDateTime;

      // Make API call with responseType: 'blob'
      const response = await apiServices.getQuotePdf(cleanedData);

      if (response.status === 200 && response.data instanceof Blob) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = `${quoteLocalData?.code}.pdf`; // ✅ dynamic name with .pdf
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        setLoading(false)
      } else {
        console.error('Failed to download PDF', response);
        toast.error('Failed to download PDF', { position: 'top-right' });
        setLoading(false)
      }
    } catch (error) {
      console.error('Error downloading PDF:', error);
      toast.error('An unexpected error occurred while downloading PDF.', { position: 'top-right' });
      setLoading(false)
    }
  };

  const handleChangeForm = () => {};

  const handleChange = () => {};

  const states = ['state1', 'state2'];

  const handleSubmit = async () => {};
  const closePopup6 = () => {
    setShowPopup6(false);
  };

  const openPopup6 = () => {
    setShowPopup6(true);
  };

  const handleClickDelete = () => {};
  const notescontainerRef = useRef(null);

  useEffect(() => {
    if (notescontainerRef.current) {
      notescontainerRef.current.scrollTop = notescontainerRef.current.scrollHeight;
    }
  }, []);

  function toTitleCaseFromCamel(str) {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2') // inserts space before capital letters
      .replace(/^./, (char) => char.toUpperCase()); // capitalize the first letter
  }

  const fetchAccountDetails = (accountId) => {
    apiServices
      .getProductsByAccountId(accountId)
      .then((response) => {
        if (response.status === 200) {
          setProductByAccountId(response?.data?.productAccountAssociations);
        }
      })
      .catch((error) => {
        console.error('Error fetching account details:', error);
      });
  };

  const [updateListFlag, setUpdateListFlag] = useState(false);

  const handleCallbackGetList = () => {
    setUpdateListFlag(true);
  };
  //   useEffect(() => {
  //   const quoteId = location.state?.id || quoteID;

  //   const fetchQuoteDetails = async () => {
  //     if (location.pathname.includes("View") && quoteId) {
  //       setLoading(true);
  //       const data ={moduleName:"Quote",id:quoteId}
  //       try {
  //         const response = await apiServices.getQuoteDetailsByQuoteId(quoteId);
  //         const response2 = await apiServices.getNotesByModuleId(data)
  //         if (response.status === 200 && response2.status===200) {
  //           const quoteDetails = response.data?.quoteDetails || [];
  //           const notesList = response2.data?.notes || [];

  //           const updatedFormData = {
  //             ...location.state,
  //             quoteDetails,
  //             notesList,
  //             type: "view",
  //             from: "view",
  //           };

  //           setFormData(updatedFormData);

  //           // ✅ Fetch products based on accountId to populate dropdown
  //           if (location.state?.accountId) {
  //             fetchAccountDetails(location.state.accountId);
  //           }

  //           setLoading(false);
  //         } else {
  //           console.error("Failed to fetch quote details:", response);
  //           setLoading(false);
  //         }
  //       } catch (err) {
  //         setLoading(false);
  //         console.error("API error in getQuoteDetailsByQuoteId (view):", err);
  //       }
  //     }
  //   };

  //   fetchQuoteDetails();
  // }, [location, quoteLocalData?.id,updateListFlag]);

  const [refreshLeadView, setRefreshLeadView] = useState(false);

  useEffect(() => {
    const quoteId = location.state?.id || quoteID;

    if (location.pathname.includes('View')) {
      setFormData({
        ...quoteLocalData,
        type: 'view',
        from: 'view',
      });
    }
    if (quoteLocalData?.accountId) {
      fetchAccountDetails(quoteLocalData?.accountId);
    }
    if (quoteId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Quote',
          id: quoteId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Quote',
          id: quoteId,
        })
      );
      dispatch(
        fetchQuoteItemsAndAppendToModule({
          moduleName: 'Quote',
          id: quoteId,
        })
      );
    }
  }, [location, quoteLocalData?.id, refreshLeadView]);

  console.log(formData);

  const isDisabled =
    quoteLocalData?.quoteStageName &&
    ['delivered', 'accepted'].includes(quoteLocalData.quoteStageName.toLowerCase()) &&
    !isSystemManager;

  const isLocked =
    quoteLocalData?.quoteStageName &&
    ['delivered', 'accepted'].includes(quoteLocalData.quoteStageName.toLowerCase());

    const isAccepted =
    quoteLocalData?.quoteStageName &&
    ['accepted'].includes(quoteLocalData.quoteStageName.toLowerCase());

  return (
    <>
      {loading && <Loader />}{' '}
      <div id="quoteAi" className="pb-0">
        <div className="viewPageOuter">
          <div className="viewHeader">
            <HeaderProfileBlock localData={quoteLocalData} moduleName={'Quotes'} View={true} />
            <div className="rightAction">
              {isLocked && (
                <i
                  class="bi bi-lock-fill"
                  title="This Quote is locked and cannot be edited due to its finalized status"
                  style={{ color: '#3a5afe' }}
                ></i>
              )}
              <div className="heading_item" id="actiongrid_dropdown">
                <div className="dropdown">
                  <button
                    className="btn action-btn mobOption dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="mob">
                      <i className="bi bi-three-dots"></i>
                    </div>{' '}
                    <div className="dsk">Convert</div>
                  </button>

                  <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li
                      className={`dropdown-item d-flex justify-content-between align-items-center ${!isAccepted ? 'disabled' : ''}`}
                      onClick={() => isAccepted && handleClickOpenConvert('')}
                    >
                      <span>Convert To Invoice</span>
                      {!isAccepted && (
                        <i
                          className="bi bi-lock-fill ms-2"
                          title="This action is locked"
                        ></i>
                      )}
                    </li>

                    <li
                      className={`dropdown-item d-flex justify-content-between align-items-center ${!isAccepted ? 'disabled' : ''}`}
                      onClick={() => isAccepted && handleClickOpenConvert('Sales')}
                    >
                      <span>Convert To Sales</span>
                      {!isAccepted && (
                        <i
                          className="bi bi-lock-fill ms-2"
                          title="This action is locked"
                        ></i>
                      )}
                    </li>
                  </ul>
                </div>
              </div>
              <button
                className={`btn btn-outline-primary ${isDisabled ? 'disabled' : ''}`}
                onClick={handleOpenEditForm}
                disabled={isDisabled}
              >
                Edit
              </button>
              {/* <button className="btn btn-outline-primary" onClick={handleOpenEditForm}>
                Edit
              </button> */}
              {/* <button className="btn btn-primary" onClick={openSendEmailPopUp}>
                Send Email
              </button> */}
              <div id="sendmail">
                <EmailPopUp
                  handleSelectChange={handleChange}
                  localData={quoteLocalData}
                  module={'Quote'}
                />
              </div>
              <button
                className="btn btn-primary d-flex align-items-center"
                onClick={downloadPdf}
                disabled={loading} // disable when loading
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Downloading...
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      fill="currentColor"
                      className="bi bi-download"
                      viewBox="0 0 16 16"
                      style={{ marginRight: '6px' }}
                    >
                      <path d="M.5 9.9a.5.5 0 0 1 .5.6v3.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10.5a.5.5 0 0 1 1 0v3.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V10.5a.5.5 0 0 1 .5-.6zm7.5-9a.5.5 0 0 1 .5.5v8.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V1.5a.5.5 0 0 1 .5-.5z" />
                    </svg>
                    Download PDF
                  </>
                )}
              </button>
            </div>
          </div>
          <div className="detailContainer">
            <div className="viewFormContainer">
              <div className="leftBlock">
                <ul>
                  {Object.keys(refs).map((key) => (
                    <li
                      key={key}
                      onClick={() => scrollToSection(key)}
                      style={{ cursor: 'pointer' }}
                      className={activeTab === key ? 'leftbox activeList' : 'leftbox'}
                    >
                      <button onClick={() => setActiveTab(key)}>{toTitleCaseFromCamel(key)}</button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="rightBlock" id="detailPageRight">
                <div className="addlead_container">
                  <div className="addleadcard1">
                    <div id="overview" className="scrollTo" ref={refs.overview}></div>
                    <RegularQuoteForm
                      handleChange={handleChange}
                      handleChangeForm={handleChangeForm}
                      handleSubmit={handleSubmit}
                      formData={quoteLocalData}
                      productsByAccountId={productsByAccountId}
                      // handleAddRow={handleAddRow}
                      // handleDeleteRow={handleDeleteRow}
                    />
                  </div>

                  <div className="tab-content">
                    {/* <Formik>
                      <Form initialValues={formData}>
                    <ChildProduct />
                    </Form>
                    </Formik> */}
                    {/* <ChildSalesOrder /> */}
                    <div id="attachments" className="scrollTo" ref={refs.attachments}></div>
                    <Attachments localData={quoteLocalData} module={'Quote'} />
                    <div id="emails" className="scrollTo" ref={refs.emails}></div>
                    <Email localData={quoteLocalData} module={'Quote'} />
                    <div id="timeline" className="scrollTo" ref={refs.timeline}></div>
                    <Timeline localData={quoteLocalData} module={'Quote'} />
                  </div>
                </div>
              </div>
            </div>
            <div className="viewFormNotesOuter">
              <div className="ViewFormNotesContainer">
                {/* <Formik
                  initialValues={formData}
                  // validationSchema={validationSchema}
                >
                  <Form id="viewForm"> */}
                <Notes leadLocalData={quoteLocalData} module={'Quote'} />
                {/* </Form>
                </Formik> */}
              </div>
            </div>
            <div
              class="offcanvas addNoteMobBlock offcanvas-end"
              tabindex="-1"
              id="offcanvasExample"
              aria-labelledby="offcanvasExampleLabel"
            >
              <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasExampleLabel">
                  <img src="../assets/images/notesIcon.svg" alt="Note" width="16px" />
                  Notes
                </h5>
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body">
                <div className="ViewFormNotesContainer">
                  <Formik
                    initialValues={formData}
                    // onSubmit={(values) => handleSubmit(values)}
                    // validationSchema={validationSchema}
                  >
                    <Form id="viewForm">
                      <Notes leadLocalData={quoteLocalData} module={'Lead'}></Notes>
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegularQuoteView;
